import { Defaults } from "src/app/Utilities/defaults";

declare var window: any;

export class DynamicEnvironment {
    public get environment() {
        return window.config.environment;
    }
    public get apiUrl() {
        return window.config.apiUrl;
    }
    public get tokenUrl() {
        return window.config.tokenUrl;
    }
    public get clinicapiUrl() {
        return window.config.clinicapiUrl;
    }
    public get clinicTokenUrl() {
        return window.config.clinicTokenUrl;
    }
    public get billingApiUrl() {
        return window.config.billingApiUrl;
    }
    public get billingTokenUrl() {
        return window.config.billingTokenUrl;
    }

    public get fluoroApiUrl() {
        return window.config.fluoroApiUrl;
    }
    public get fluoroTokenUrl() {
        return window.config.fluoroTokenUrl;
    }
    public get documentUrl() {
        return window.config.documentUrl;
    }
    public get orderTrackerUrl() {
        return window.config.orderTrackerUrl;
    }
    public get reportsUrl() {
        return window.config.reportsUrl;
    }
    public get key() {
        return window.config.key;
    }
    public get iv() {
        return window.config.iv;
    }
    public get prescriptionDays() {
        return window.config.PrescriptionDays;
    }
    public set key(ckey: string) {
        window.config.key = ckey;
        //return window.config.key
    }
    public set iv(civ: string) {
        window.config.iv = civ;
    }
    public get uploadFIleSize() {
        return window.config.uploadFIleSize;
    }

    public get telemedicinUrl() {
        return window.config.telemedicinUrl;
    }

    public get PatTextMessage() {
        return window.config.PatTextMessage;
    }
    public get patientPortalApiUrl() {
        return window.config.patientPortalApiUrl;
    }
    public get patientPortalTokenUrl() {
        return window.config.patientPortalTokenUrl;
    }
    public get IsEnableTelemedicine() {
        return window.config.IsEnableTelemedicine;
    }
    public get TeleVoiceURL() {
        return window.config.TeleVoiceURL;
    }
    public get CheckInternetConnection() {
        return window.config.CheckInternetConnection;
    }
    public get ClinicalDataExport_DownloadURL() {
        return window.config.ClinicalDataExport_DownloadURL;
    }
    public get Blockduration() {
        return window.config.Blockduration;
    }
    public get IsTaskAndMessages() {
        return window.config.IsTaskAndMessages;
    }
    public get ISONCEnabled() {
        return window.config.ISONCEnabled;
    }

    public get msgAttachmentUrl() {
        return window.config.msgAttachmentUrl;
    }
    public get IntervalTime() {
        return window.config.IntervalTime;
    }

    public get checkedIndocumentUrl() {
        return window.config.checkedIndocumentUrl;
    }
    public get messagedomain() {
        return window.config.messagedomain;
    }
    public get pdmpreporturl() {
        return window.config.pdmpreporturl;
    }

    public get signaturePOPUrl() {
        return window.config.signaturePOPUrl;
    }


    //---------------Document Library Changes-------------------------
    // public get DocLibraryTargetLocation ()
    // {

    //    return  Defaults.DocLibraryTargetLocation;
    // }

    // public get DocLibraryFieldNames ()
    // {
    //    return  Defaults.DocLibraryFieldNames;
    // }
    // public get DocLibraryDocCategoryID ()
    // {
    //    return  Defaults.DocLibraryDocCategoryID;
    // }
    // public get DocLibraryPatDemographicsID ()
    // {
    //    return   Defaults.DocLibraryPatDemographicsID;
    // }

    // public get DocLibraryCheckinForm ()
    // {
    //    return  Defaults.DocLibraryCheckinForm;
    // } 
    // public get DocLibraryVisitNote ()
    // {
    //    return  Defaults.DocLibraryVisitNote;
    // } public get DocLibraryORNote ()
    // {
    //    return   Defaults.DocLibraryORNote;
    // }
    public get ClientIpAdressURL() {
        return window.config.ClientIpAdressURL;
    }
    //*** Register Activation Page */
    public get IsRegisterActivationLink() {
        return window.config.IsRegisterActivationLink;
    }
    
    public get chpayerurl() {
        return window.config.chpayerurl;
    }

    public get videoResourcesUrl() {
        return window.config.videoResourcesUrl;
    }

    public get emrHelpUrl() {
        return window.config.emrHelpUrl;
    }


}